/**
 * Константы маршрутов приложения
 */
export const AppRoutes = {
  /**
   * Главная страница, редирект на выбор сеанса
   */
  ROOT: '/',

  /**
   * Страница выбора даты и времени сеанса
   */
  DATE_SELECTION: '/date-selection',

  /**
   * Страница выбора мест в зале
   */
  SEATS_SELECTION: '/seats-selection',

  /**
   * Страница оформления заказа
   */
  CHECKOUT: '/checkout',
} as const;

/**
 * Порядок шагов оформления заказа
 */
export const BOOKING_STEPS = [
  AppRoutes.DATE_SELECTION,
  AppRoutes.SEATS_SELECTION,
  AppRoutes.CHECKOUT,
] as const;
